import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: "Portada",
            component: () => import("@/views/pages/Portada")
        },
        {
            path: "/section",
            component: () => import("@/views/layout/Layout"),
            children: [
                {
                    path: "/events",
                    name: "Events",
                    component: () => import("@/views/pages/publico/events/Index")
                },
                {
                    path: "/detalle",
                    name: "Details",
                    component: () => import("@/views/pages/publico/events/Details")
                }
            ]
        },
        {
            path: '/home',
            redirect: "/dashboard",
            component: () => import("@/views/layout/System"),
            meta: { requiresAuth: true },
            children: [
                {
                    path: "/dashboard",
                    name: "dashboard",
                    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/pages/Dashboard"),
                    meta: { requiresAuth: true },
                },
                {
                    path: "/payroll",
                    name: "payroll",
                    component: () => import(/* webpackChunkName: "playroll" */ "@/views/pages/payroll/Index"),
                    meta: { requiresAuth: true }
                },
                {
                    path: "/participate",
                    name: "Participate",
                    component: () => import(/* webpackChunkName: "athlete" */ "@/views/pages/acreditation/Index"),
                    meta: { requiresAuth: true },
                },
                {
                    path: "/participate/:slug",
                    name: "DetalleEvento",
                    component: () => import(/* webpackChunkName: "athlete" */ "@/views/pages/acreditation/DetailsEvent"),
                    meta: { requiresAuth: true },
                },
                {
                    path: "/black-belts",
                    name: "BlackBeltsList",
                    component: () => import( "@/views/pages/BlackBelts/List"),
                    meta: { requiresAuth: true },

                },





                {
                    path: "/official",
                    name: "official",
                    component: () => import(/* webpackChunkName: "official" */ "@/views/pages/acreditation/Official"),
                    meta: { requiresAuth: true }
                },
                {
                    path: "/taekwondo",
                    name: "taekwondo",
                    component: () => import(/* webpackChunkName: "taekwondo" */ "@/views/pages/acreditation/Taekwondo"),
                    meta: { requiresAuth: true },
                    props: true
                },
                {
                    path: "/wushu",
                    name: "wushu",
                    component: () => import(/* webpackChunkName: "taekwondo" */ "@/views/pages/acreditation/Wushu"),
                    meta: { requiresAuth: true },
                    props: true
                },
                {
                    path: "/ajedrez",
                    name: "ajedrez",
                    component: () => import(/* webpackChunkName: "taekwondo" */ "@/views/pages/acreditation/Ajedrez"),
                    meta: { requiresAuth: true },
                    props: true
                },
                {
                    path: "/karate",
                    name: "karate",
                    component: () => import(/* webpackChunkName: "taekwondo" */ "@/views/pages/acreditation/Karate"),
                    meta: { requiresAuth: true },
                    props: true
                },
                {
                    path: "/lev-pesas",
                    name: "levpesas",
                    component: () => import(/* webpackChunkName: "taekwondo" */ "@/views/pages/acreditation/LPesas"),
                    meta: { requiresAuth: true },
                    props: true
                },
                {
                    path: "/e-sports",
                    name: "esports",
                    component: () => import(/* webpackChunkName: "sports" */ "@/views/pages/acreditation/eSports"),
                    meta: { requiresAuth: true },
                    props: true
                },
                {
                    path: "/athlete-history",
                    name: "athletehistory",
                    component: () => import(/* webpackChunkName: "athletehistory" */ "@/views/pages/Athletehistory"),
                    meta: { requiresAuth: true }
                },
                {
                    path: "/credentials",
                    name: "credentials",
                    component: () => import(/* webpackChunkName: "credentials" */ "@/views/pages/Credentials"),
                    meta: { requiresAuth: true }
                },
                {
                    path: "/tutorials",
                    name: "tutoriales",
                    component: () => import(/* webpackChunkName: "credentials" */ "@/views/pages/Tutorials"),
                    meta: { requiresAuth: true }
                }
            ]
        },
        {
            path: "/credential/:id",
            name: "ValCredential",
            component: () => import(/* webpackChunkName: "taekwondo" */ "@/views/pages/validation/Credential"),
        },
        {
            path: "/login",
            component: () => import(/* webpackChunkName: "login" */ "@/views/pages/auth/Login"),
            children: [
                {
                    name: "login",
                    path: "/login",
                    component: () => import("@/views/pages/auth/Login")
                }
            ]
        },
        {
            // the 404 route, when none of the above matches
            path: "/404",
            name: "404",
            component: () => import("@/views/pages/error/Error.vue")
        }
    ]
});

/*
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    linkActiveClass: "menu-item-active",
    linkExactActiveClass: "menu-item-active"
})*/

/*router.beforeEach((to, from, next) => {
  if(to.matched.some(route => route.meta.requiresAuth)){
    if(!store.getters.isAuthenticated){
      next('/login');
    }else{
      next();
    }
  }else{
    next();
  }
});*/

//export default router
